import { InvalidTimeframe } from '../../error';
import { EpochMilliHasSecondsDefined } from './EpochMilliHasSecondsDefined';
import { validateMillisSinceEpochIsAtSecondPrecision } from './ValidateMillisSinceEpochIsAtSecondPrecision';
// i.e if i wanted to seal 1 second of audio, starting at the 5 second mark, then this is represented as "[5,6)"
export function validateTimeframeExclusive(timeframe) {
    const { start, end } = timeframe;
    if (end < start || start === end) {
        throw new InvalidTimeframe(timeframe);
    }
}
export function validateTimeframeBoundsHaveSecondPrecision(timeframe) {
    const { start, end } = timeframe;
    const epochMilliHasSecondsDefined = !validateMillisSinceEpochIsAtSecondPrecision(start) || !validateMillisSinceEpochIsAtSecondPrecision(end);
    if (epochMilliHasSecondsDefined) {
        throw new EpochMilliHasSecondsDefined(timeframe);
    }
}
export function validatePositiveInteger(timeframe) {
    const { start, end } = timeframe;
    const isInt = (n) => n % 1 === 0;
    const areLessThanZero = start < 0 || end < 0;
    const areNotIntegers = !isInt(start) || !isInt(end);
    if (areLessThanZero || areNotIntegers) {
        throw new InvalidTimeframe(timeframe);
    }
}
